// src/components/DigitalRain.jsx
import React, { useEffect, useRef } from "react";

// ---- CHANGE #1: We accept loadingText as a prop, defaulting to an empty string.
export default function DigitalRain ({ loadingText = "" }) {
  const canvasRef = useRef(null);

  // ---- CHANGE #2: A simple function to generate random color each character.
  function getRandomColor() {
    return "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const fontSize = 16;
    const columns = Math.floor(canvas.width / fontSize);

    // Each column has a 'drop' which is basically how far down it’s “raining”
    const drops = [];
    for (let i = 0; i < columns; i++) {
      drops[i] = 1;
    }

    // If loadingText has emoji/symbols, the canvas can render blocks.
    // Keep a safe ASCII set for the rain effect.
    const safeText = String(loadingText || "")
      .replace(/[^\x20-\x7E]/g, "")
      .trim();
    const characters = safeText || "VONTHEKEYZ";

    function draw() {
      if (!ctx || !canvas) return;

      // fade the canvas slightly for trailing effect
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // set the font
      ctx.font = `${fontSize}px "Oxanium", "Segoe UI", monospace`;
      ctx.textBaseline = "top";

      // draw each column
      for (let i = 0; i < drops.length; i++) {
        // pick a random character from loadingText
        const text = characters.charAt(Math.floor(Math.random() * characters.length));
        // ---- CHANGE #4: For each character, randomize the color
        ctx.fillStyle = getRandomColor();
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        // if the drop is off screen, reset occasionally
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.95) {
          drops[i] = 0;
        }
        drops[i]++;
      }
    }

    const intervalId = setInterval(draw, 50);

    function handleResize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(intervalId);
    };
  }, [loadingText]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "black" }}>
      <canvas ref={canvasRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
